import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RemoveUsersFromDataAlertsParams {
  dataAlertIds: string[];
  userIds: string[];
}

export class RemoveUsersFromDataAlertsRequest extends Request<RemoveUsersFromDataAlertsParams, IResult> {
  constructor(params: RemoveUsersFromDataAlertsParams) {
    super('removeUsersFromDataAlerts', params);
  }
}
